/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AbsenceDepartmentDutyRosterResult,
  DepartmentDutyRosterResult,
  GetForExistingLeaveRequestParams,
  GetForNewLeaveRequestParams,
  MyWorkareaDutyRosterParams
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetForNewLeaveRequestUrl = (params?: GetForNewLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`
}

export const getForNewLeaveRequest = async (params?: GetForNewLeaveRequestParams, options?: RequestInit): Promise<AbsenceDepartmentDutyRosterResult> => {
  
  return customInstance<AbsenceDepartmentDutyRosterResult>(getGetForNewLeaveRequestUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetForNewLeaveRequestQueryKey = (params?: GetForNewLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetForNewLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForNewLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForNewLeaveRequest>>> = ({ signal }) => getForNewLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetForNewLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getForNewLeaveRequest>>>
export type GetForNewLeaveRequestQueryError = ErrorType<unknown>


export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForNewLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetForNewLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetForNewLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForNewLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForNewLeaveRequest>>> = ({ signal }) => getForNewLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetForNewLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getForNewLeaveRequest>>>
export type GetForNewLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForNewLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetForNewLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetForExistingLeaveRequestUrl = (params?: GetForExistingLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`
}

export const getForExistingLeaveRequest = async (params?: GetForExistingLeaveRequestParams, options?: RequestInit): Promise<AbsenceDepartmentDutyRosterResult> => {
  
  return customInstance<AbsenceDepartmentDutyRosterResult>(getGetForExistingLeaveRequestUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetForExistingLeaveRequestQueryKey = (params?: GetForExistingLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetForExistingLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForExistingLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForExistingLeaveRequest>>> = ({ signal }) => getForExistingLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetForExistingLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getForExistingLeaveRequest>>>
export type GetForExistingLeaveRequestQueryError = ErrorType<unknown>


export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForExistingLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetForExistingLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetForExistingLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForExistingLeaveRequestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForExistingLeaveRequest>>> = ({ signal }) => getForExistingLeaveRequest(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetForExistingLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getForExistingLeaveRequest>>>
export type GetForExistingLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForExistingLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetForExistingLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMyWorkareaDutyRosterUrl = (params?: MyWorkareaDutyRosterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`
}

export const myWorkareaDutyRoster = async (params?: MyWorkareaDutyRosterParams, options?: RequestInit): Promise<DepartmentDutyRosterResult> => {
  
  return customInstance<DepartmentDutyRosterResult>(getMyWorkareaDutyRosterUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMyWorkareaDutyRosterQueryKey = (params?: MyWorkareaDutyRosterParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMyWorkareaDutyRosterQueryOptions = <TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMyWorkareaDutyRosterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof myWorkareaDutyRoster>>> = ({ signal }) => myWorkareaDutyRoster(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MyWorkareaDutyRosterQueryResult = NonNullable<Awaited<ReturnType<typeof myWorkareaDutyRoster>>>
export type MyWorkareaDutyRosterQueryError = ErrorType<unknown>


export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  MyWorkareaDutyRosterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMyWorkareaDutyRosterQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMyWorkareaDutyRosterSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMyWorkareaDutyRosterQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof myWorkareaDutyRoster>>> = ({ signal }) => myWorkareaDutyRoster(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MyWorkareaDutyRosterSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof myWorkareaDutyRoster>>>
export type MyWorkareaDutyRosterSuspenseQueryError = ErrorType<unknown>


export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  MyWorkareaDutyRosterParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMyWorkareaDutyRosterSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




